import React, { Component, Fragment } from "react";
import autoBind from "auto-bind";
import { connect } from "react-redux";

import clickWrap from "@js/helpers/click_wrap.js";
import classNames from "@js/helpers/class_names.js";

import { ceScreenEditorOpen } from "@js/actions/studio/campaign_content_section/screen_editor.js";
import { ceModalEditNameOpen } from "@js/actions/studio/campaign_content_section/modal_edit_name.js";
import { ceModalEditSubjectOpen } from "@js/actions/studio/campaign_content_section/modal_edit_subject.js";
import { ceMakeMultipart } from "@js/actions/studio/campaign_content_section/multi_part_contents.js";

import StudioCampaignContentTile from "@js/components/studio/campaign_content_section/studio_campaign_content_tile.jsx";
import StudioCampaignContentDropdownMenu from "@js/components/studio/campaign_content_section/studio_campaign_content_dropdown_menu.jsx";

const SmallButton = (props) => {
  return (
    <a
      href="#"
      className="studio-link-button"
      onClick={clickWrap(props.onClick)}
    >
      {props.children}
    </a>
  );
};

const ContentRow = (props) => {
  let rowClassName = classNames({
    "content-row-information-row": true,
    dangerous: props.dangerous,
  });
  return (
    <Fragment>
      <div className={rowClassName}>
        <div className="content-row-header">
          <div className="content-row-title">
            <strong>{props.title || ""}</strong>
          </div>
          <div className="content-row-body">
            {props.dangerous ? <strong>{props.text}</strong> : props.text}
            <div className="content-row-footer">
              {props.allow_editing && (
                <SmallButton onClick={props.onLinkClick}>
                  {props.buttonText}
                </SmallButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const SubjectComponent = (props) => (
  <ContentRow
    title={t(`phrases.react_content.content_row.subject`)}
    onLinkClick={() => {
      props.dispatch(ceModalEditSubjectOpen(props.client_content_id));
    }}
    buttonText={
      props.subject
        ? t(`phrases.react_content.content_row.edit`)
        : t(`phrases.react_content.content_row.add`)
    }
    text={
      props.subject
        ? props.subject
        : t(`phrases.react_content.content_row.subject_not_defined`)
    }
    allow_editing={props.allow_editing}
    dangerous={!props.subject || props.subject.length === 0}
  />
);

const NameComponent = (props) => (
  <ContentRow
    title={t(`phrases.react_content.content_row.name`)}
    onLinkClick={() =>
      props.dispatch(ceModalEditNameOpen(props.client_content_id))
    }
    buttonText={t(`phrases.react_content.content_row.edit`)}
    text={props.name}
    allow_editing={props.allow_editing}
  />
);

const EmailFormatComponent = (props) => {
  let otherContentType = props.format === "text" ? "html" : "text";

  let editAction =
    props.format === "both"
      ? ceScreenEditorOpen(props.client_content_id, otherContentType)
      : ceMakeMultipart(props.client_content_id);

  let editLabel =
    props.format === "both"
      ? t(`phrases.react_content.content_row.edit_${otherContentType}`)
      : t(`phrases.react_content.content_row.add_${otherContentType}`);

  let hasBlankText = props.format !== "html" && props.text === "";

  let text = (
    <div>
      {t(`phrases.react_content.content_row.format_${props.format}`)}
      &nbsp;
      {props.format !== "text" && hasBlankText && (
        <Fragment>
          <br />
          {t(`phrases.react_content.content_row.text_part_not_defined`)}
        </Fragment>
      )}
    </div>
  );

  return (
    <ContentRow
      title={t("standard_fields.email_format")}
      text={text}
      dangerous={hasBlankText && props.format === "both"}
      allow_editing={props.allow_editing}
      onLinkClick={() => props.dispatch(editAction)}
      buttonText={editLabel}
    />
  );
};

const UnsubscribeLinkMissingWarning = (props) => (
  <ContentRow
    title={t("phrases.error")}
    text={t(`phrases.react_content.missing_unsubscribe_link`)}
    dangerous
    allow_editing={false}
  />
);

class StudioCampaignContentRow extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    if (!this.props.content) return null;
    let content = this.props.content;
    let isBlank =
      content.format !== "text" ? content.html === "" : content.text === "";
    return (
      <Fragment>
        <div className="studio-campaign-content-row">
          <StudioCampaignContentTile
            content={content}
            allow_editing={this.props.allow_editing}
          />

          <div className="studio-campaign-content-row-information">
            <div id="information-rows">
              <SubjectComponent
                dispatch={this.props.dispatch}
                subject={content.subject}
                client_content_id={content.client_content_id}
                allow_editing={this.props.allow_editing}
              />

              {!this.props.isOnlyContent && (
                <NameComponent
                  dispatch={this.props.dispatch}
                  name={content.name}
                  client_content_id={content.client_content_id}
                  allow_editing={this.props.allow_editing}
                />
              )}

              <EmailFormatComponent
                format={content.format}
                dispatch={this.props.dispatch}
                client_content_id={content.client_content_id}
                text={content.text || ""}
                allow_editing={this.props.allow_editing}
              />
              {!isBlank && content.unsub_tag_missing && (
                <UnsubscribeLinkMissingWarning />
              )}
            </div>
            <StudioCampaignContentDropdownMenu
              content={this.props.content}
              isOnlyContent={this.props.isOnlyContent}
              allow_editing={this.props.allow_editing}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  allow_editing: state.library.allow_editing,
});

export default connect(mapStateToProps)(StudioCampaignContentRow);
